import React from "react";
import { useTranslation } from "react-i18next";
import { View, Text, ActivityIndicator } from "react-native";

interface TimerExchangeProps {
  isOperationInProgress: boolean;
  minutes: number;
  seconds: number;
}

export default function TimerExchange(props: TimerExchangeProps) {
  const { t } = useTranslation();
  return (
    <View>
      {props.isOperationInProgress ? (
        <View className="flex-row items-center justify-center gap-3">
          <ActivityIndicator
            size="small"
            animating={props.isOperationInProgress}
            color="#7529E2"
          />
          <Text
            className={`text-xl font-light ${
              !props.isOperationInProgress && "hidden"
            }`}
          >
            {t("home/exchange:fetchingrate")}
          </Text>
        </View>
      ) : (
        <Text className="text-xl font-thin">{`${t(
          "home/exchange:remainingtime"
        )}: ${props.minutes.toString().padStart(2, "0")}:${props.seconds
          .toString()
          .padStart(2, "0")}`}</Text>
      )}
    </View>
  );
}
